export function createPalette (colors) {
  return colors.reduce((o, c) => {
    const names = c.name.split('/');

    if (!names[0]?.startsWith('_')) {
      let current = o;
      names.forEach((n, idx) => {
        if (n !== 'colors') {
          const t = n === 'contrast' ? 'contrastText' : n;
          current[t] = current[t] ?? (idx < names.length - 1 ? {} : c.color);
          current = current[n];
        }
      });
    }

    return o;
  }, {});
}


const colors = {
  createPalette
};

export default colors;
